import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createVNode as _createVNode, vModelSelect as _vModelSelect, resolveDirective as _resolveDirective, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "page-wr" }
const _hoisted_2 = {
  key: 0,
  class: "card"
}
const _hoisted_3 = { class: "default-form" }
const _hoisted_4 = { class: "input-row with-double" }
const _hoisted_5 = { class: "logo-wr" }
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 1,
  class: "logo-title"
}
const _hoisted_8 = ["accept"]
const _hoisted_9 = { class: "input-row double" }
const _hoisted_10 = { class: "input-wr double" }
const _hoisted_11 = {
  key: 0,
  class: "input-wr double"
}
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "input-row" }
const _hoisted_14 = { class: "input-wr" }
const _hoisted_15 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_16 = { class: "input-wr" }
const _hoisted_17 = {
  key: 0,
  class: "input-wr"
}
const _hoisted_18 = ["value"]
const _hoisted_19 = { class: "input-row" }
const _hoisted_20 = { class: "input-wr" }
const _hoisted_21 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_22 = {
  key: 0,
  class: "input-wr"
}
const _hoisted_23 = { class: "input-row" }
const _hoisted_24 = { class: "input-wr" }
const _hoisted_25 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_26 = { class: "input-row" }
const _hoisted_27 = { class: "input-wr" }
const _hoisted_28 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_29 = { class: "input-row" }
const _hoisted_30 = { class: "input-wr" }
const _hoisted_31 = ["value"]
const _hoisted_32 = ["value"]
const _hoisted_33 = ["value"]
const _hoisted_34 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_35 = {
  key: 0,
  class: "input-row"
}
const _hoisted_36 = { class: "input-wr" }
const _hoisted_37 = { class: "toggle-block toggle-title-bold" }
const _hoisted_38 = { class: "input-row bordered" }
const _hoisted_39 = { class: "input-wr input-price-wr" }
const _hoisted_40 = { class: "initial-deposit-wrapper" }
const _hoisted_41 = { class: "input-row" }
const _hoisted_42 = { class: "input-wr" }
const _hoisted_43 = { class: "toggle-block toggle-title-bold" }
const _hoisted_44 = {
  key: 0,
  class: "toggle-description"
}
const _hoisted_45 = {
  key: 1,
  class: "toggle-description"
}
const _hoisted_46 = {
  key: 1,
  class: "error-hint"
}
const _hoisted_47 = { class: "input-wr input-price-wr" }
const _hoisted_48 = { class: "show-price-wrapper" }
const _hoisted_49 = { class: "input-row" }
const _hoisted_50 = { class: "input-wr" }
const _hoisted_51 = { class: "toggle-block toggle-title-bold" }
const _hoisted_52 = { class: "toggle-description" }
const _hoisted_53 = {
  key: 0,
  class: "input-wr"
}
const _hoisted_54 = { class: "input-row" }
const _hoisted_55 = { class: "input-wr" }
const _hoisted_56 = { class: "toggle-block toggle-title-bold" }
const _hoisted_57 = {
  key: 1,
  class: "input-wr"
}
const _hoisted_58 = { class: "input-row" }
const _hoisted_59 = { class: "input-wr" }
const _hoisted_60 = { class: "toggle-block toggle-title-bold" }
const _hoisted_61 = { class: "input-row" }
const _hoisted_62 = {
  key: 0,
  class: "input-wr"
}
const _hoisted_63 = { class: "input-row" }
const _hoisted_64 = { class: "input-wr" }
const _hoisted_65 = { class: "toggle-block toggle-title-bold" }
const _hoisted_66 = { class: "custom-terms-section" }
const _hoisted_67 = { class: "input-row" }
const _hoisted_68 = { class: "input-wr" }
const _hoisted_69 = { class: "input-row" }
const _hoisted_70 = { class: "toggle-block" }
const _hoisted_71 = { class: "input-row" }
const _hoisted_72 = { class: "input-wr" }
const _hoisted_73 = { class: "label" }
const _hoisted_74 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_75 = { class: "input-row" }
const _hoisted_76 = { class: "toggle-block" }
const _hoisted_77 = {
  key: 1,
  class: "input-row refundable"
}
const _hoisted_78 = { class: "toggle-block" }
const _hoisted_79 = {
  key: 0,
  class: "toggle-description"
}
const _hoisted_80 = { class: "buttons" }
const _hoisted_81 = {
  key: 1,
  class: "spinner"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_tippy = _resolveDirective("tippy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[36] || (_cache[36] = _createElementVNode("h2", { class: "title-main" }, "Edit Estate", -1)),
    (!$setup.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("form", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("label", _hoisted_5, [
                ($setup.logoPreview)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      class: "preview",
                      src: $setup.logoPreview
                    }, null, 8, _hoisted_6))
                  : (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString($setup.estate?.title), 1)),
                _createElementVNode("input", {
                  class: "file-input",
                  type: "file",
                  onChange: _cache[0] || (_cache[0] = ($event: any) => ($setup.selectFile($event))),
                  accept: $setup.logoTypes
                }, null, 40, _hoisted_8)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _cache[18] || (_cache[18] = _createElementVNode("label", { class: "label" }, "Estate icon color", -1)),
                  _createElementVNode("label", {
                    class: "input-color",
                    style: _normalizeStyle({ 'background-color': $setup.form.iconColor })
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.form.iconColor) = $event)),
                      type: "color"
                    }, null, 512), [
                      [_vModelText, $setup.form.iconColor]
                    ])
                  ], 4)
                ]),
                (!$setup.isAdminEdit)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _cache[19] || (_cache[19] = _createElementVNode("label", { class: "label" }, "Contact Person", -1)),
                      _createElementVNode("input", {
                        class: "input",
                        value: $setup.getFirstLastName($setup.estate.landownerId),
                        type: "text",
                        readonly: "",
                        placeholder: "Contact Person"
                      }, null, 8, _hoisted_12)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _cache[20] || (_cache[20] = _createElementVNode("label", { class: "label" }, "Estate Name", -1)),
                _withDirectives(_createElementVNode("input", {
                  class: _normalizeClass(["input", { error: $setup.v$.title.$error }]),
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.form.title) = $event)),
                  type: "text",
                  placeholder: "Estate Name"
                }, null, 2), [
                  [_vModelText, $setup.form.title]
                ]),
                ($setup.v$.title.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString($setup.v$.title.$errors[0].$message), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_16, [
                (!$setup.isAdminEdit)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _cache[21] || (_cache[21] = _createElementVNode("label", { class: "label" }, "Email", -1)),
                      _createElementVNode("input", {
                        class: "input",
                        value: $setup.estate.landownerId.email,
                        type: "email",
                        readonly: "",
                        placeholder: "Email"
                      }, null, 8, _hoisted_18)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _cache[22] || (_cache[22] = _createElementVNode("label", { class: "label" }, "Short Estate Name (9 characters)", -1)),
                _withDirectives(_createElementVNode("input", {
                  class: _normalizeClass(["input", { error: $setup.v$.shortTitle.$error }]),
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.form.shortTitle) = $event)),
                  type: "text",
                  placeholder: "Estate Name",
                  maxlength: "9"
                }, null, 2), [
                  [_vModelText, $setup.form.shortTitle]
                ]),
                ($setup.v$.shortTitle.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString($setup.v$.shortTitle.$errors[0].$message), 1))
                  : _createCommentVNode("", true)
              ]),
              (!$setup.isAdminEdit)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _cache[23] || (_cache[23] = _createElementVNode("label", { class: "label" }, "Phone", -1)),
                    _createVNode($setup["Cleave"], {
                      class: "input",
                      modelValue: $setup.estate.landownerId.phone,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.estate.landownerId.phone) = $event)),
                      options: $setup.phoneNumberOption($setup.estate.landownerId.phone),
                      type: "text",
                      readonly: "",
                      placeholder: "0412 345 678"
                    }, null, 8, ["modelValue", "options"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _cache[24] || (_cache[24] = _createElementVNode("label", { class: "label" }, "Estate address", -1)),
                _withDirectives(_createElementVNode("input", {
                  class: _normalizeClass(["input", { error: $setup.v$.address.$error }]),
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.form.address) = $event)),
                  type: "text",
                  placeholder: "Estate address"
                }, null, 2), [
                  [_vModelText, $setup.form.address]
                ]),
                ($setup.v$.address.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString($setup.v$.address.$errors[0].$message), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _cache[26] || (_cache[26] = _createElementVNode("label", { class: "label" }, "App Version", -1)),
                _withDirectives(_createElementVNode("select", {
                  class: _normalizeClass(["input", { error: $setup.v$.appVersion.$error }]),
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.form.appVersion) = $event))
                }, [...(_cache[25] || (_cache[25] = [
                  _createElementVNode("option", { value: "v1" }, "V1", -1),
                  _createElementVNode("option", { value: "v2" }, "V2", -1)
                ]))], 2), [
                  [_vModelSelect, $setup.form.appVersion]
                ]),
                ($setup.v$.appVersion.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString($setup.v$.appVersion.$errors[0].$message), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _cache[28] || (_cache[28] = _createElementVNode("label", { class: "label" }, "Estate Type", -1)),
                _withDirectives(_createElementVNode("select", {
                  class: _normalizeClass(["input", { error: $setup.v$.type.$error }]),
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.form.type) = $event))
                }, [
                  _cache[27] || (_cache[27] = _createElementVNode("option", {
                    value: undefined,
                    disabled: ""
                  }, "Select type", -1)),
                  _createElementVNode("option", {
                    value: $setup.EstateType.LEGACY
                  }, "Legacy", 8, _hoisted_31),
                  _createElementVNode("option", {
                    value: $setup.EstateType.RESIDENTIAL_COMMUNITY
                  }, "Residential Community", 8, _hoisted_32),
                  _createElementVNode("option", {
                    value: $setup.EstateType.LAND_SUBDIVISION
                  }, "Land Subdivision", 8, _hoisted_33)
                ], 2), [
                  [_vModelSelect, $setup.form.type]
                ]),
                ($setup.v$.type.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString($setup.v$.type.$errors[0].$message), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            ($setup.isSuperAdmin && $setup.form.type === $setup.EstateType.LAND_SUBDIVISION)
              ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, [
                      _createVNode($setup["ToggleButton"], {
                        modelValue: $setup.hlPackagesEnabled,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.hlPackagesEnabled) = $event)),
                        additionalClass: 'large',
                        labelBold: 'toggle-title-font bolder',
                        label: "H&L Packages"
                      }, null, 8, ["modelValue"]),
                      _cache[29] || (_cache[29] = _createElementVNode("div", { class: "toggle-description" }, "Enables package management for the landowner and package visibility for buyers. Existing packages are preserved while this feature is disabled.", -1))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("div", _hoisted_42, [
                      _createElementVNode("div", _hoisted_43, [
                        _withDirectives(_createVNode($setup["ToggleButton"], {
                          modelValue: $setup.initDepositCondition,
                          "onUpdate:modelValue": [
                            _cache[9] || (_cache[9] = ($event: any) => (($setup.initDepositCondition) = $event)),
                            $setup.setDepositAndRefundable
                          ],
                          disabled: !$setup.isTrustAccountConnected && !$setup.isAdminEdit,
                          additionalClass: 'large',
                          labelBold: 'toggle-title-font bolder',
                          label: "Initial deposit"
                        }, null, 8, ["modelValue", "disabled"]), [
                          [_directive_tippy, { content: !$setup.isTrustAccountConnected && !$setup.isAdminEdit ? $setup.tooltipText : '', theme: 'light-border', placement: 'top' }]
                        ]),
                        ($setup.initDepositCondition)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_44, "Buyers will be required to pay an initial holding deposit when completing a Contract information form."))
                          : (_openBlock(), _createElementBlock("div", _hoisted_45, "Buyers will not be required to pay an initial holding deposit when completing a Contract information form."))
                      ])
                    ])
                  ])
                ]),
                ($setup.initDepositCondition)
                  ? (_openBlock(), _createBlock($setup["Cleave"], {
                      key: 0,
                      class: _normalizeClass(["input deposit", [{ error: $setup.v$.initDeposit.$error }]]),
                      id: "deposit",
                      modelValue: $setup.form.initDeposit,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.form.initDeposit) = $event)),
                      modelModifiers: { trim: true },
                      type: "text",
                      placeholder: "Initial deposit",
                      onBlur: $setup.v$.initDeposit.$touch,
                      options: $setup.initDepositOptions
                    }, null, 8, ["modelValue", "class", "onBlur"]))
                  : _createCommentVNode("", true),
                ($setup.v$.initDeposit.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_46, _toDisplayString($setup.v$.initDeposit.$errors[0].$message), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("div", _hoisted_49, [
                    _createElementVNode("div", _hoisted_50, [
                      _createElementVNode("div", _hoisted_51, [
                        _createVNode($setup["ToggleButton"], {
                          modelValue: $setup.form.hidePrice,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.form.hidePrice) = $event)),
                          additionalClass: 'large',
                          labelBold: 'toggle-title-font bolder',
                          label: "Hide pricing"
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_52, "Pricing information will be " + _toDisplayString($setup.form.hidePrice ? "hidden" : "visibleable") + " on the interactive masterplan.", 1)
                      ])
                    ])
                  ])
                ])
              ]),
              ($setup.isSuperAdmin)
                ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                    _createElementVNode("div", _hoisted_54, [
                      _createElementVNode("div", _hoisted_55, [
                        _createElementVNode("div", _hoisted_56, [
                          _createVNode($setup["ToggleButton"], {
                            class: "disable-initial-hold",
                            additionalClass: 'large',
                            modelValue: $setup.form.showInitialHold,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.form.showInitialHold) = $event)),
                            labelBold: 'toggle-title-font bolder',
                            label: "Show Initial Hold Functionality"
                          }, null, 8, ["modelValue"])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              ($setup.isSuperAdmin)
                ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                    _createElementVNode("div", _hoisted_58, [
                      _createElementVNode("div", _hoisted_59, [
                        _createElementVNode("div", _hoisted_60, [
                          _createVNode($setup["ToggleButton"], {
                            class: "disable-initial-hold",
                            additionalClass: 'large',
                            modelValue: $setup.form.showDocusign,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.form.showDocusign) = $event)),
                            labelBold: 'toggle-title-font bolder',
                            label: "Show Docusign Functionality"
                          }, null, 8, ["modelValue"])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_61, [
              ($setup.isSuperAdmin)
                ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                    _createElementVNode("div", _hoisted_63, [
                      _createElementVNode("div", _hoisted_64, [
                        _createElementVNode("div", _hoisted_65, [
                          _createVNode($setup["ToggleButton"], {
                            class: "disable-initial-hold",
                            additionalClass: 'large',
                            modelValue: $setup.form.showDontHaveSolicitorEOI,
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.form.showDontHaveSolicitorEOI) = $event)),
                            labelBold: 'toggle-title-font bolder',
                            label: "Show Solicitor Option"
                          }, null, 8, ["modelValue"])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_66, [
              _cache[32] || (_cache[32] = _createElementVNode("h3", { class: "section-title" }, "Custom terms", -1)),
              _createElementVNode("div", _hoisted_67, [
                _createElementVNode("div", _hoisted_68, [
                  _cache[30] || (_cache[30] = _createElementVNode("label", { class: "label" }, "Default custom terms", -1)),
                  _withDirectives(_createElementVNode("textarea", {
                    class: "input textarea",
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (($setup.form.customTerms.text) = $event)),
                    placeholder: "Default custom terms"
                  }, null, 512), [
                    [_vModelText, $setup.form.customTerms.text]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_69, [
                _createElementVNode("div", _hoisted_70, [
                  _createVNode($setup["ToggleButton"], {
                    modelValue: $setup.form.customTerms.showOnlyCustomTerms,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (($setup.form.customTerms.showOnlyCustomTerms) = $event)),
                    additionalClass: 'large',
                    labelBold: 'toggle-title-font bold',
                    label: "Show only custom terms"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              ($setup.form.collaboratorCustomTerms?.length)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _cache[31] || (_cache[31] = _createElementVNode("h3", { class: "section-title" }, "Collaborator custom terms", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.form.collaboratorCustomTerms, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "collaborator-custom-terms",
                        key: item.businessId
                      }, [
                        _createElementVNode("div", _hoisted_71, [
                          _createElementVNode("div", _hoisted_72, [
                            _createElementVNode("label", _hoisted_73, _toDisplayString($setup.getBusinessName(item.businessId)), 1),
                            _withDirectives(_createElementVNode("textarea", {
                              class: "input textarea",
                              "onUpdate:modelValue": ($event: any) => ((item.customTerms.text) = $event),
                              placeholder: `Custom terms for ${$setup.getBusinessName(item.businessId)}`
                            }, null, 8, _hoisted_74), [
                              [_vModelText, item.customTerms.text]
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_75, [
                          _createElementVNode("div", _hoisted_76, [
                            _createVNode($setup["ToggleButton"], {
                              modelValue: item.customTerms.showOnlyCustomTerms,
                              "onUpdate:modelValue": ($event: any) => ((item.customTerms.showOnlyCustomTerms) = $event),
                              additionalClass: 'large',
                              labelBold: 'toggle-title-font bold',
                              label: "Show only custom terms"
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ])
                        ])
                      ]))
                    }), 128))
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            ($setup.initDepositCondition)
              ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                  _createElementVNode("div", _hoisted_78, [
                    _createVNode($setup["ToggleButton"], {
                      modelValue: $setup.form.isRefundable,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (($setup.form.isRefundable) = $event)),
                      additionalClass: 'large',
                      labelBold: 'toggle-title-font bold',
                      label: "Refundable"
                    }, null, 8, ["modelValue"]),
                    ($setup.initDepositCondition)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                          _cache[33] || (_cache[33] = _createTextVNode("Buyers will be notified before submitting a Contract information", -1)),
                          _cache[34] || (_cache[34] = _createElementVNode("br", null, null, -1)),
                          _createTextVNode(" form that the holding deposit is " + _toDisplayString(`${$setup.form.isRefundable ? "" : " not"} refundable.`), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_80, [
            _createElementVNode("button", {
              class: "button default primary",
              onClick: $setup.updateEstate
            }, "Save Changes"),
            _createVNode(_component_router_link, {
              class: "button default cancel",
              to: { name: !$setup.isAdminEdit ? 'LandownerProfileEstates' : 'AdminEstate' }
            }, {
              default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                _createTextVNode("Cancel", -1)
              ]))]),
              _: 1
            }, 8, ["to"])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_81))
  ]))
}